document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const app = document.querySelector("#app-embed");
    if (!app || !app.shadowRoot) return;

    observer.disconnect();
    const shadow = app.shadowRoot;

    const form = shadow.querySelector('form[data-testid="form"]');
    const submitBtn = shadow.querySelector('button[type="submit"]');
    if (!form || !submitBtn) return;

    const sheet = new CSSStyleSheet();

    sheet.insertRule(`
      ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
        margin: 0 !important;
        margin-top: 100px !important;
        margin-bottom: 100px !important;
        max-width: 800px !important;
      }
    `);

    sheet.insertRule(`
      @media screen and (max-width: 990px) {
       #form-container-ref ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
          margin-top: 24px !important;
          margin-bottom: 36px !important;
        } 
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 [class*="_formHeader_"] {
        margin: 0;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 [class*="_formHeader_"] ._textHeading_2aowh_35 {
        margin: 0;
        margin-bottom: 16px;  
        color: var(--color-brand-dark-opacity-600, rgba(62, 39, 35, 0.60));
        text-align: center;
        font-family: "CabinetGrotesk";
        font-size: var(--size-ph-lg, 16px);
        font-style: normal;
        font-weight: 400;
        line-height: 176%;
        letter-spacing: -0.16px;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 [class*="_formHeader_"] ._textBody_2aowh_10 p {
        margin: 0;
        margin-bottom: 32px;
        color: var(--color-brand-palette-dark-brown, #3E2723);
        text-align: center;
        font-family: "CabinetGrotesk";
        font-size: 36px;
        font-style: normal;
        font-weight: 300;
        line-height: 124%;
        letter-spacing: -0.54px;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 [class*="_formFieldset_"] {
        display: flex !important;
        flex-flow: row wrap !important;
        row-gap: 8px !important;
        column-gap: 16px !important;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 {
        width: 100% !important;
        margin: 0 !important;
        box-sizing: border-box !important;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:has([id="custom#budget"]),
      ._formFieldContainer_1mxsl_5:has([id="custom#timeline"]) {
        width: calc(50% - 8px) !important;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 [class*="_formFieldset_"] input._formInputField_nag3b_7 {
        background-color: transparent !important;
        padding: 1.2rem 2rem !important;
        border-radius: .4rem !important;
        color: #3e272399 !important;
        border: 1px solid #3E272333 !important;
        box-shadow: none !important;
        height: 49px !important;
        box-sizing: border-box;
      }
    `);

    sheet.insertRule(`
      ._formFileInputContent_k0hif_26 {
        background-color: transparent !important;
        border-radius: .4rem !important;
        color: #3E2723 !important;
        box-shadow: none !important;
        height: 49px !important;
        box-sizing: border-box;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 textarea {
        background: transparent;
        padding: 1.2rem 2rem !important;
        border-radius: .4rem !important;
        color: #3e272399 !important;
        border: 1px solid #3E272333 !important;
        box-shadow: none !important;
        height: 220px !important;
        box-sizing: border-box;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:has(textarea)::before {
        display: none !important;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 ._formInputFieldLabel_1mxsl_38 {
        color: var(--color-brand-dark-opacity-500, rgba(62, 39, 35, 0.50));
        font-family: "CabinetGrotesk";
        font-size: 14px;
        font-weight: 400;
        line-height: 94%;
        letter-spacing: 0.14px;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38 {
        top: 10.5px !important;
      }
    `);

    sheet.insertRule(`
      ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74 {
        top: 10.5px !important;
      }
    `);

    sheet.insertRule(`
      [class*="_formFileInput_"] ._textBody_2aowh_10 {
        display: none !important;
      }
    `);

    sheet.insertRule(`
      [class*="_formFileInput_"] {
        margin: 0 !important;
        padding: 0 !important;
        width: auto !important;
        display: inline-block !important;
      }
    `);

    sheet.insertRule(`
      [class*="_formFileInput_"] [class*="_formFileInputField_"] {
        margin-top: 10px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 10px !important;
        background-color: transparent !important;
        border: 1px solid #3E2723 !important; 
        color: #3E2723 !important;             
        border-radius: 4px !important;         
        padding: 10px 24px !important;         
        cursor: pointer !important;
        width: auto !important;
        height: 40px !important;
        box-shadow: none !important;
        box-sizing: border-box !important;
        transition: all 0.2s ease !important;
      }
    `);

    sheet.insertRule(`
      [class*="_formFileInput_"] [class*="_formFileInputButton_"] {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        gap: 10px;
        margin: 0 !important;
        padding: 0;
        background: transparent;
        font-size: 0;
      }
    `);

    sheet.insertRule(`
      [class*="_formFileInput_"] [class*="_formFileInputButton_"]::before {
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 10V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V10M11.3333 5.33333L8 2M8 2L4.66667 5.33333M8 2V10' stroke='%233E2723' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: contain;
      }
    `);

    sheet.insertRule(`
      [class*="_formFileInput_"] [class*="_formFileInputButton_"]::after {
        content: "Upload Image";
        font-family: "CabinetGrotesk", sans-serif;
        font-weight: 400;
        font-size: 14px;
        color: #3E2723;
      }
    `);

    sheet.insertRule(`
      [class*="_formFileInput_"] [class*="_formFileInputFileName_"] {
        font-family: "CabinetGrotesk", sans-serif !important;
        font-weight: 400 !important;
        font-size: 14px !important;
        color: #3E2723 !important;
      }
    `);

    sheet.insertRule(`
      .custom-consent {
        width: 100%;
        margin-top: 24px;
      }
    `);

    sheet.insertRule(`
      .custom-consent__label {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        cursor: pointer;
        user-select: none;
        font-family: DM Sans;
        font-size: 14px;
        line-height: 20px;
        color: #3F3F3F;
        margin-bottom: 4px;
      }
    `);

    sheet.insertRule(`
      .custom-consent__input {
        display: none;
      }
    `);

    sheet.insertRule(`
      .custom-consent__checkbox {
        display: flex !important;
        width: 20px;
        height: 20px;
        border: 2px solid rgba(141, 110, 99, 1);
        border-radius: 6px;
        box-sizing: border-box;
        transition: all 0.2s ease;
      }
    `);

    sheet.insertRule(`
      .custom-consent__input:checked + .custom-consent__checkbox {
        background-color: rgb(141, 110, 99) !important;
        border-color: rgb(141, 110, 99) !important;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
        background-size: 14px;
        background-repeat: no-repeat;
        background-position: center;
      }
    `);

    sheet.insertRule(`
      .custom-consent__text {
        color: var(--Avad-Brand-100, #212629);
        font-family: "CabinetGrotesk";
        font-size: 14px;
        font-weight: 400;
        line-height: 176%;
        letter-spacing: 0.42px;
      }
    `);

    sheet.insertRule(`
      ._inline_1q1d2_47 [class*="_formFieldset_"] [class*="_formSubmitButton_"] {
        margin: 0 auto;  
        margin-top: 20px;  
        width: 125px;  
        cursor: pointer;
        height: 4rem;
        padding: 1.4rem 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        font-family: CabinetGrotesk, sans-serif;
        font-size: 1.4rem;
        font-weight: 400;
        color: #fffcf8;
        background-color: #3e2723;
        border-radius: .2rem;
        text-decoration: none;
        border: none;
        transition: .3s ease-in-out;
        box-sizing: border-box !important;
      }
    `);

    shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];

    if (!shadow.querySelector(".custom-consent")) {
      const consent = document.createElement("div");
      consent.className = "custom-consent";

      consent.innerHTML = `
        <label class="custom-consent__label">
          <input type="checkbox" class="custom-consent__input" />
          <span class="custom-consent__checkbox"></span>
          <span class="custom-consent__text">
              I would like to receive news and updates
          </span>
        </label>
        <label class="custom-consent__label">
          <input type="checkbox" required class="custom-consent__input" />
          <span class="custom-consent__checkbox"></span>
          <span class="custom-consent__text">
              I agree to the Terms and Conditions
          </span>
        </label>
      `;

      submitBtn.before(consent);

      form.addEventListener("submit", (e) => {
        const requiredCheckbox = consent.querySelector("input[required]");

        if (requiredCheckbox && !requiredCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();

          requiredCheckbox.setCustomValidity("Please accept the terms.");
          requiredCheckbox.reportValidity();

          requiredCheckbox.addEventListener(
            "input",
            () => {
              requiredCheckbox.setCustomValidity("");
            },
            { once: true },
          );
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
